import { getFileDownloadSignedUrl } from 'store/files/services/getFileDownloadSignedUrl.service';

// Module-level cache for full-size download signed URLs, shared between
// ImagePreviewDialog and MobileImageViewer so swiping to an already-prefetched
// neighbor never shows a spinner. Entries expire because the presigned URLs
// themselves do; TTL is kept well under the backend's expiry.
const TTL_MS = 4 * 60 * 1000;

const cache = new Map(); // filePermissionId -> { promise, fetchedAt }

export function getSignedUrlCached(filePermissionId) {
  const hit = cache.get(filePermissionId);
  if (hit && Date.now() - hit.fetchedAt < TTL_MS) {
    return hit.promise;
  }
  const promise = getFileDownloadSignedUrl(filePermissionId);
  cache.set(filePermissionId, { promise, fetchedAt: Date.now() });
  promise.catch(() => cache.delete(filePermissionId));
  return promise;
}

export function hasFreshSignedUrl(filePermissionId) {
  const hit = cache.get(filePermissionId);
  return Boolean(hit && Date.now() - hit.fetchedAt < TTL_MS);
}

export function invalidateSignedUrl(filePermissionId) {
  cache.delete(filePermissionId);
}
